import React from 'react'
import styled, { keyframes } from 'styled-components'
import { LAYOUT_UNITS } from '@/constants/legacy/constLayout'

const SkeletonRootCategoryTab = () => {
  return (
    <StyledRootCategory>
      <StyledRootCategoryTabList>
        {Array.from({ length: 10 }).map((_, index) => (
          <StyledRootCategoryTab key={index} />
        ))}
      </StyledRootCategoryTabList>
    </StyledRootCategory>
  )
}

const StyledRootCategory = styled.div`
  width: ${LAYOUT_UNITS.BODY_MAX_WIDTH};
  overflow-x: hidden;
`

const StyledRootCategoryTabList = styled.div`
  width: max-content;
  height: ${({ theme: { spacing } }) => spacing.size48};
  display: flex;
  justify-content: left;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme: { spacing } }) => spacing.size8};
  padding-left: ${({ theme: { spacing } }) => spacing.size16};
  border-bottom: ${({ theme: { spacing } }) => spacing.size1} solid ${({ theme: { color } }) => color.gray70};
`

const shineLines = keyframes`
  0% {
    background-position: -100px;
  }
  40%, 100% {
    background-position: 100px;
  }
`

const StyledRootCategoryTab = styled.div`
  width: 5rem;
  height: 2.3rem;
  display: inline-block;
  border-radius: ${({ theme: { spacing } }) => spacing.size4};
  background-image: linear-gradient(
    90deg,
    ${({ theme: { color } }) => color.gray70} 0px,
    ${({ theme: { color } }) => color.gray50} 40px,
    ${({ theme: { color } }) => color.gray70} 80px
  );
  background-size: 600px;
  animation: ${shineLines} 3.5s infinite;
`

export default SkeletonRootCategoryTab
